export default "__VITE_ASSET__D0EUi6Wk__"